import { render, staticRenderFns } from "./SearchChapter.vue?vue&type=template&id=20a1cf72&"
import script from "./SearchChapter.vue?vue&type=script&lang=ts&"
export * from "./SearchChapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports